import { render, staticRenderFns } from "./QuestionLoader.vue?vue&type=template&id=390d234e&scoped=true&"
import script from "./QuestionLoader.vue?vue&type=script&lang=js&"
export * from "./QuestionLoader.vue?vue&type=script&lang=js&"
import style0 from "./QuestionLoader.vue?vue&type=style&index=0&id=390d234e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390d234e",
  null
  
)

export default component.exports